import { Injectable } from '@angular/core';
import { UsuarioTenant } from '../../contracts/models/usuariotenant.model';
import { map } from 'rxjs/operators';
import { UserDto, User } from '../../contracts/models/user.model';
import { Api } from '../../contracts/classes/api.class';
import { Observable } from 'rxjs';
import { ApiResult } from '../../contracts/types/api-response.type';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UsuariotenantService extends Api {

    getUsuariosTenants(): Observable<UsuarioTenant[]> {
        return this.http.get<UsuarioTenant[]>(`${this.url}/userTenants`);
    }

    getUsuarioTenant(id: number): Observable<UsuarioTenant> {
        return this.http.get<UsuarioTenant>(`${this.url}/userTenants/${id}`);
    }

    createUsuarioTenant(data: UsuarioTenant): Observable<UsuarioTenant> {
        return this.http.post<UsuarioTenant>(`${this.url}/userTenants`, data);
    }

    updateUsuarioTenant(id: number, data: UsuarioTenant): Observable<UsuarioTenant> {
        return this.http.put<UsuarioTenant>(`${this.url}/userTenants/${id}`, data);
    }

    deleteUsuarioTenant(id: number): Observable<any> {
        return this.http.delete<any>(`${this.url}/userTenants/${id}`);
    }

    getSelectTenantsByUser(id: number): Observable<any>{
        return this.http.get<any>(`${this.url}/userTenants/tenants-select-by-user-id/${id}`);
    }

}

